<span class="fw-semibold">
  {{ 'shared:tfa.mspQRCode.enableTwoFactorAuth' | i18next }}
</span>
<ol class="pl-4">
  <li class="mt-2">
    {{ 'shared:tfa.downloadApplication' | i18next }}
    <mbs-install-msp-app-badges></mbs-install-msp-app-badges>
  </li>
  <li class="mt-2">
    <div>{{ 'shared:tfa.mspQRCode.openApplication' | i18next }}</div>
    <span>{{ 'shared:tfa.youMayBePromptedTo' | i18next }}</span>
    <ul>
      <li>{{ 'shared:tfa.enablePushNotifications' | i18next }}</li>
      <li>{{ 'shared:tfa.allowNotifications' | i18next }}</li>
      <li>{{ 'shared:tfa.allowCamera' | i18next }}</li>
    </ul>
  </li>
  <li class="mt-2">
    <span [innerHTML]="'shared:tfa.scanInstruction' | i18next"></span>
  </li>
</ol>
